import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-900 text-primary-100">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-8 px-4 py-12 md:px-6 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg text-background-50">
              风
            </span>
            <div>
              <p className="font-heading text-lg font-semibold text-background-50">
                风流女管家
              </p>
              <p className="text-xs text-primary-200">影视剧介绍与剧情解析</p>
            </div>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-200">
            专注《风流女管家》及同题材优秀剧集的内容整理，提供剧情梗概、演员资料与剧集点评，帮助观众更全面地了解作品。
          </p>
        </div>

        <div>
          <h4 className="mb-3 text-sm font-semibold text-background-50">内容导航</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/" className="transition-colors hover:text-accent-300">
                首页
              </Link>
            </li>
            <li>
              <Link
                to="/category"
                className="transition-colors hover:text-accent-300"
              >
                剧集分类
              </Link>
            </li>
            <li>
              <Link
                to="/category?tab=actor"
                className="transition-colors hover:text-accent-300"
              >
                演员介绍
              </Link>
            </li>
            <li>
              <Link
                to="/reviews/fengliu-nvguandian"
                className="transition-colors hover:text-accent-300"
              >
                剧集点评
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="mb-3 text-sm font-semibold text-background-50">关于站点</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <Link
                to="/about"
                className="transition-colors hover:text-accent-300"
              >
                关于我们
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className="transition-colors hover:text-accent-300"
              >
                联系我们
              </Link>
            </li>
          </ul>
          <p className="mt-4 text-xs leading-relaxed text-primary-200">
            本站图片与剧情内容均为示意展示，仅供学习交流使用，如涉版权问题请联系我们处理。
          </p>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="mx-auto flex w-full max-w-6xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-primary-200 sm:flex-row md:px-6">
          <p>© 2024 风流女管家影视内容站 · 保留所有权利</p>
          <p>本站内容为演示用途，剧情与人物均为虚构</p>
        </div>
      </div>
    </footer>
  );
}